module.exports = __webpack_public_path__ + "static/media/mystery-boxes-nft-sr03.38e4a86f.png";